/**
 * What the caller's country is allowed to decide about the interface
 * language.
 *
 * Two different things, deliberately. Outside Iran `/geo/locale` only
 * *suggests* — it answers `en`, which seeds the language for a visitor who
 * has never picked one and is ignored once someone has (an Iranian abroad
 * keeps the FA toggle). From an Iranian IP it *rules*: the Persian site is
 * the only one shown and the FA/EN toggles disappear, because the Enamad
 * trust seal (components/site/EnamadSeal.jsx) is registered against the
 * Persian site and has to sit on the page an Iranian visitor actually gets.
 *
 * A Map, not an object literal: `lockedLanguage('constructor')` must be
 * null, not a function off Object.prototype.
 */
const LOCKED_COUNTRIES = new Map([['IR', 'fa']])

/** The language a country forces, or null where the visitor still chooses. */
export function lockedLanguage(country) {
  return LOCKED_COUNTRIES.get(country) ?? null
}

/**
 * The language to render once `/geo/locale` has answered, and whether the
 * visitor may still change it.
 *
 * @param {{ country?: string|null, locale?: string }|null|undefined} geo
 *   The endpoint's answer; anything missing or unrecognised means "no opinion".
 * @param {{ language: string, languageSource: 'auto'|'manual' }} prefs
 *   The live preferences — read at the moment the answer lands, never a
 *   snapshot taken before the request went out.
 * @returns {{ language: string, locked: boolean }}
 */
export function languageAfterGeo(geo, prefs) {
  const forced = lockedLanguage(geo?.country)
  if (forced) return { language: forced, locked: true }

  const hint = geo?.locale
  if (prefs.languageSource === 'auto' && (hint === 'fa' || hint === 'en')) {
    return { language: hint, locked: false }
  }
  return { language: prefs.language, locked: false }
}
